import { frontendURL } from '../../../helper/URLHelper';
import ClientsIndex from './pages/ClientsIndex.vue';
import ClientManageView from './pages/ClientManageView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'client_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/clients'),
    component: ClientsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'clients_dashboard_index',
        component: ClientsIndex,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'clients_dashboard_segments_index',
        component: ClientsIndex,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'clients_dashboard_labels_index',
        component: ClientsIndex,
        meta: commonMeta,
      },
      {
        path: 'active',
        name: 'clients_dashboard_active',
        component: ClientsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/clients/:clientId'),
    component: ClientManageView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'clients_edit',
        component: ClientManageView,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'clients_edit_segment',
        component: ClientManageView,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'clients_edit_label',
        component: ClientManageView,
        meta: commonMeta,
      },
    ],
  },
];
